import {Component, inject} from '@angular/core'
import {MatIconButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {ConfigService} from '../../services/config.service'
import {RouterLink} from '@angular/router'
import {DarkComponent} from '../dark/dark.component'

@Component({
  selector: 'vmb-header',
  imports: [
    MatMenu,
    MatIcon,
    MatMenuItem,
    MatMenuTrigger,
    MatIconButton,
    RouterLink,
    DarkComponent
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  public configService: ConfigService = inject(ConfigService)
}
